import { useCallback, useContext } from 'react';
import StepContext from './StepContext';

const getPrevStep = (current, first) => Math.max(first, current - 1);
const getNextStep = (current, last) => Math.min(last, current + 1);

function useStep() {
    const { currentStep, setCurrentStep, steps } = useContext(StepContext);
    const firstStep = 1;
    const lastStep = steps.length;
    const isFirstStep = currentStep === firstStep;
    const isLastStep = currentStep === lastStep;
    const nextStep = getNextStep(currentStep, lastStep);
    const previousStep = getPrevStep(currentStep, firstStep);
    const gotoStep = useCallback(
        (step) => {
            if (step === currentStep) {
                return;
            }

            if (step < firstStep || step > lastStep) {
                return;
            }

            if (step > currentStep && !steps[step - 2]?.isDone) {
                return;
            }

            setCurrentStep(step);
        },
        [currentStep, firstStep, lastStep, steps]
    );
    const gotoNextStep = useCallback(() => setCurrentStep((current) => getNextStep(current, lastStep)), [lastStep]);
    const gotoPreviousStep = useCallback(() => setCurrentStep((current) => getPrevStep(current, firstStep)), [
        firstStep,
    ]);
    const getStepName = (step) => steps[step - 1].name;

    return {
        currentStep,
        getStepName,
        gotoStep,
        gotoNextStep,
        gotoPreviousStep,
        firstStep,
        lastStep,
        isFirstStep,
        isLastStep,
        nextStep,
        previousStep,
    };
}

export default useStep;
